import { FundingTypeEnum } from './types';

export const FundingTypeTextMapper = {
  [FundingTypeEnum.Invalid]: 'NA',
  [FundingTypeEnum.Realtime]: '1m',
  [FundingTypeEnum.DelayedHour8]: '8h',
  [FundingTypeEnum.ImmediateHour8]: '8h',
  [FundingTypeEnum.ImmediateHour4]: '4h',
  [FundingTypeEnum.ImmediateHour2]: '2h',
  [FundingTypeEnum.ImmediateHour1]: '1h',
} as const;

// funding cycle = 24hour / x
export const FundingTypeTimeMapper = {
  [FundingTypeEnum.Invalid]: 'NA',
  [FundingTypeEnum.Realtime]: 60 * 24, // (24 hour / 1 minute = 1440)
  [FundingTypeEnum.DelayedHour8]: 3,
  [FundingTypeEnum.ImmediateHour8]: 3,
  [FundingTypeEnum.ImmediateHour4]: 6,
  [FundingTypeEnum.ImmediateHour2]: 12,
  [FundingTypeEnum.ImmediateHour1]: 24,
};
